
/**Maps the subscriptions to hub spot */
export const subscriptionsMap: Record<string, string> = {
    // "1": "Free",
    "2": "Monthly",
    "3": "Annual"
}

export const Subscriptions = {
    GB:
        [
            // {
            //     id: "1",
            //     name: "Free",
            //     priceOptions: {
            //         price: 0,
            //         percent: 2,
            //         tier: "Month"
            //     },
            //     currency: "£"
            // },
            {
                id: "2",
                name: "Monthly",
                priceOptions: {
                    price: 40,
                    percent: 1.5,
                    tier: "Month"
                },
                currency: "£"
            },
            {
                id: "3",
                name: "Annual",
                priceOptions: {
                    price: 399,
                    percent: 1,
                    tier: "Year"
                },
                currency: "£"
            }
        ],
    US: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 3.15,
        //         tier: "Month"
        //     },
        //     currency: "$"
        // },
    ],
    CA: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 3.15,
        //         tier: "Month"
        //     },
        //     currency: "$"
        // },
    ],
    AU: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 2,
        //         tier: "Month"
        //     },
        //     currency: "$"
        // },
    ],
    NZ: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 3.15,
        //         tier: "Month"
        //     },
        //     currency: "$"
        // },
    ],
    FR: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 1.75,
        //         tier: "Month"
        //     },
        //     currency: "€"
        // },
    ],
    IE: [
        // {
        //     id: "1",
        //     name: "Free",
        //     priceOptions: {
        //         price: 0,
        //         percent: 1.75,
        //         tier: "Month"
        //     },
        //     currency: "€"
        // },
    ]
}